import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'
import { Tabs, Tab } from 'material-ui/Tabs'

const EditMember = (props) => {
  return (
    <Tabs>
      <Tab label='Edit'>
        <Edit
// @ts-ignore
          title='Edit Group Member'
          fields={fields}
          apiPath={`admin/group_users/${props.params.memberId}`}
          successRedirectPath='/write-now/members'
          buildMenuItems={menuItems}
        />
      </Tab>
      <Tab label='Merge Fields'>
        <Edit
// @ts-ignore
          title='Merge Fields'
          fields={[
            { name: 'Mid-Program Survey Link', prop: 'mid_program_survey_link', type: 'text' },
            { name: 'End-of-Program Survey Link', prop: 'end_of_program_survey_link', type: 'text' },
            { name: 'User Merge Field 1', prop: 'user_merge_field_1', type: 'text' },
            { name: 'User Merge Field 2', prop: 'user_merge_field_2', type: 'text' },
            { name: 'User Merge Field 3', prop: 'user_merge_field_3', type: 'text' }
          ]}
          apiPath={`admin/group_users/${props.params.memberId}/merge_fields`}
          successRedirectPath={`/write-now/members/${props.params.memberId}/edit`}
          disableDelete
          buildMenuItems={menuItems}
        />
      </Tab>
    </Tabs>
  )
}

export default EditMember
